module.exports = __webpack_public_path__ + "static/media/veh.electrico.7f3ee758.png";